import { styled } from '@mui/system'

const WelcomeFooter = styled('div')(({ theme }) => ({
	position: 'absolute',
	bottom: 0,
	left: 0,
	right: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	color: theme.palette.common.black,
	fontSize: '1.25rem',

	'> a': {
		color: theme.palette.common.black,
		textDecoration: 'none',
		marginLeft: '0.5rem',
		fontFamily: 'Gilroy-SemiBold',
	},
}))

export { WelcomeFooter }
